/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('componentEditorWorkflow', [
  '$location',

  function ($location) {
    return {
      controller: 'ComponentEditorWorkflowController',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./_component-editor-workflow.html'),

      replace: true,

      scope: {
        component: '=',
      },

      link(scope, element, attrs) {},
    };
  },
]);
